<ng-container *transloco="let t">
  <div class="flex h-full w-full flex-col">
    <div class="mb-4 flex items-center justify-between border-b border-gray-100 pb-4">
      <div class="flex items-center gap-4">
        @if (creations().length > 0) {
          <div class="flex items-center gap-1.5 text-sm">
            <app-bulk-upload-type-icon [type]="BulkUploadPreviewStatus.CREATION" />
            <div>
              {{ creations().length }}
              <span class="text-gray-500">{{ t("bulk-upload-preview.creations", [creations().length]) }}</span>
            </div>
          </div>
        }
        @if (updates().length > 0) {
          <div class="flex items-center gap-1.5 text-sm">
            <app-bulk-upload-type-icon [type]="BulkUploadPreviewStatus.UPDATE" />
            <div>
              {{ updates().length }}
              <span class="text-gray-500">{{ t("bulk-upload-preview.updates", [updates().length]) }}</span>
            </div>
          </div>
        }
        @if (errors().length > 0) {
          <div class="flex items-center gap-1.5 text-sm">
            <app-bulk-upload-type-icon
              [type]="BulkUploadPreviewStatus.VALUE_ERROR"
              [iTooltip]="t('bulk-upload-preview.ignored_rows_disclaimer')"
              iTooltipPlacement="top-center"
            />
            <div>
              {{ errors().length }}
              <span class="text-gray-500">{{ t("bulk-upload-preview.errors", [errors().length]) }}</span>
            </div>
          </div>
        }
        @if (unchanged().length > 0) {
          <div class="flex items-center gap-1.5 text-sm">
            <app-bulk-upload-type-icon [type]="BulkUploadPreviewStatus.UNCHANGED" />
            <div>
              {{ unchanged().length }}
              <span class="text-gray-500">{{ t("bulk-upload-preview.unchanged", [unchanged().length]) }}</span>
            </div>
          </div>
        }
      </div>

      <div class="flex items-center gap-2">
        <div class="mr-2 border-r border-gray-100 pr-4">
          <app-bulk-upload-type-filter
            [selectedTypes]="selectedTypesFilter()"
            (selectedTypesChange)="typeFilterChanged($event)"
          />
        </div>
        <button iButton variant="secondary" (click)="back.emit()">{{ t("bulk-upload-preview.back") }}</button>
        <button iButton [disabled]="!canUpload()" (click)="upload.emit()">
          {{ t("bulk-upload-preview.start_import") }}
        </button>
      </div>
    </div>
    <div class="ag-theme-quartz ag-theme-quartz-light flex-1">
      <ag-grid-angular class="h-full" [gridOptions]="gridOptions()"> </ag-grid-angular>
    </div>
  </div>
</ng-container>
